import { useLoaderData } from 'react-router';
import { PaginatedProjects } from '@modules/professional/component/projects-tab/PaginatedProjects';
import type { PreviewDisabledFeatures } from '@modules/root/hook/use-is-disabled-in-preview';
import { useIsDisabledInPreview } from '@modules/root/hook/use-is-disabled-in-preview';
import type { APHandle } from '~/modules/root';
import type { loader } from '@modules/professional/page/loaders/projects-page-loader.server';
import { useTilesAdminData } from '~/modules-rocco/admin/hooks/use-tiles-admin-data';
import type { TileViewModel } from '@rocco/ui/tile-shared/view-models/tile';
import type { ProjectTileViewModel } from '@rocco/ui/tile-project/view-models/project';

const disabledInPreview: PreviewDisabledFeatures = {
    featured_tile_links: false,
};

export const handle: APHandle = {
    category: 'project',
    disabledInPreview,
    hideContactArchiPro: true,
};

const ProjectsPage = () => {
    const { searchResult, pagination, filterStates, projectTilesRocco } =
        useLoaderData<typeof loader>();
    const disableTileLink = useIsDisabledInPreview('featured_tile_links');
    const disableSaveToDesignBoard =
        useIsDisabledInPreview('save_design_board');
    const disableSort = useIsDisabledInPreview('directory_sort');
    const projectTilesRoccoAdmin = useTilesAdminData(
        projectTilesRocco as TileViewModel<ProjectTileViewModel>[],
    );

    return (
        <PaginatedProjects
            searchResult={searchResult}
            pagination={pagination}
            filterStates={filterStates}
            projectTilesRocco={projectTilesRoccoAdmin}
            disableTileLink={disableTileLink}
            disableSaveToDesignBoard={disableSaveToDesignBoard}
            disableSort={disableSort}
        />
    );
};

export default ProjectsPage;
